<template>
    <li class="faq-item mb-2">
        <div class="faq-item__question flex">
            <i class="faq-item__question__icon icon-question-mark" />
            <p class="faq-item__question__content mb-0 mx-3">
                {{ item.question }}
            </p>
        </div>
        <div class="faq-item__answer">
            <div
                :aria-labelledby="`answer-${_uid}`"
                class="collapse"
                :id="`collapse-${_uid}`"
                role="tabpanel"
            >
                <div class="faq-item__answer__content p-3 pb-2">
                    <!-- eslint-disable vue/no-v-html -->
                    <div v-html="item.answer" class="mb-2" />
                    <!-- eslint-enable vue/no-v-html -->
                    <ul v-if="item.links && item.links.length" class="mb-2">
                        <li v-for="(link, j) in item.links" :key="j">
                            <a :href="link.address" :rel="link.rel" :target="link.target">
                                {{ link.text }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="faq-item__button text-center" :id="`answer-${_uid}`" role="tab">
            <a
                :aria-controls="`collapse-${_uid}`"
                aria-expanded="false"
                :data-parent="`#accordion`"
                data-toggle="collapse"
                :href="`#collapse-${_uid}`"
                class="flex"
            >
                <p v-if="$device.mobile" class="mb-0 ml-2">پاسخ</p>
                <i class="icon-arrow-down-12 show-answer" />
            </a>
        </div>
    </li>
</template>

<script>

export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';
@import 'assets/styles/mixins/shadow';

.faq-item {
    border-radius: 3px;
    @include shadow(1);
    background-color: $snow-white;

    &__question {
        padding: 15px 9px 0;
        border-bottom: 1px solid $gray-lighter;
        align-items: center;

        &__icon {
            font-size: 35px;
            color: $orange;
        }

        &__content {
            color: $gray-darker;
        }
    }

    &__answer {

        &__content {
            color: $gray-darker;
        }
    }

    &__button {
        background-color: $gray-light;

        a {
            color: $gray-darker;
            justify-content: center;
            align-items: center;

            i {
                transition: transform 0.5s ease;
                color: $gray;
            }

            &[ aria-expanded = 'true' ] {

                i {
                    transform: rotateZ(180deg);
                }
            }
        }
    }
}

@media (min-width: 992px) {

    .faq-item {
        position: relative;

        &__answer {
            z-index: 2;
        }

        &__question {
            padding: 17px 20px;
        }

        &__button {
            background: none;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;

            a {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 70px;

                .show-answer {
                    position: absolute;
                    left: 20px;
                    top: 28px;
                }
            }
        }
    }
}
</style>
